module.exports = __webpack_public_path__ + "static/media/IMG_0766.0c960fbc.JPG";